exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.help-text[data-v-19d6ba03] {\n  text-align: center;\n}\n", ""]);

// exports
